import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/**
 * 路由meta说明----------------------------------
 * auth: true登录才能访问，false不需要登录，默认 true
 * name: 页面标题
 */
export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/pay/weixin/activity/coupons/:id',
      title: '活动',
      meta: {auth: false, title: '活动', name: 'activity'},
      component: resolve => require(['views/activity/coupons'], resolve)
    },
    {
      path: '/',
      title: '职道网',
      meta: {auth: true, title: '首页', name: 'home'},
      redirect: '/index',
      component: resolve => require(['views/containers/full'], resolve),
      children: [
        // 全局搜索
        {
          path: '/search/:search',
          meta: {auth: true, title: '全站搜索', name: 'search'},
          component: resolve => require(['views/search/search'], resolve)
        },
        // 资料详情
        {
          path: '/material',
          meta: {auth: true, title: '学习资料'},
          component: resolve => require(['views/material'], resolve)
        },
        {
          path: '/material/:id',
          meta: {auth: true, title: '资料详情'},
          component: resolve => require(['views/material/detail'], resolve)
        },
        // region 求职者
        {
          path: '/student/home',
          meta: {auth: true, title: '求职者面板', name: 'student'},
          component: resolve => require(['views/student/home'], resolve)
        },
        {
          path: '/student/novice',
          meta: {auth: true, title: '学员新手引导'},
          component: resolve => require(['views/student/student-guide'], resolve)
        },
        {
          path: '/student/guide',
          meta: {auth: true, title: '求职者引导', name: 'student'},
          component: resolve => require(['views/student/guide'], resolve)
        },
        {
          path: '/student/settings',
          meta: {auth: true, title: '求职者设置'},
          component: resolve => require(['views/student/settings'], resolve)
        },
        {
          path: '/student/info/:id',
          meta: {auth: true, title: '求职者主页'},
          component: resolve => require(['views/student/info'], resolve)
        },
        {
          path: '/student/task/',
          meta: {auth: true, title: '任务'},
          component: resolve => require(['views/student/task/list'], resolve)
        },
        {
          path: '/student/task/detail/:id/:pid/:type',
          meta: {auth: true, title: '任务详情'},
          component: resolve => require(['views/student/task/detail'], resolve)
        },
        {
          path: '/student/practice',
          meta: {auth: true, title: '实习'},
          component: resolve => require(['views/student/practice/'], resolve)
        },
        {
          path: '/student/agreement/my',
          meta: {auth: true, title: '协议'},
          component: resolve => require(['views/student/agreement/my'], resolve)
        },
        {
          path: '/student/agreement/create/:id',
          meta: {auth: true, title: '签协议'},
          component: resolve => require(['views/student/agreement/create'], resolve)
        },
        {
          path: '/student/agreement/detail/:id',
          meta: {auth: true, title: '协议详情'},
          component: resolve => require(['views/student/agreement/detail'], resolve)
        },

        {
          path: '/student/resume/jobSeeker',
          meta: {auth: true, title: '简历详情'},
          component: resolve => require(['views/student/resume/jobSeeker'], resolve)
        },
        {
          path: '/student/test/detail/:id',
          meta: {auth: true, title: '测试详情'},
          component: resolve => require(['views/student/test'], resolve)
        },
        {
          path: '/student/resume/record',
          meta: {auth: true, title: '履历维护'},
          component: resolve => require(['views/student/resume/record/'], resolve)
        },
        {
          path: '/student/resume/detail/:id',
          meta: {auth: true, title: '数据简历'},
          component: resolve => require(['views/student/resume/record/detail'], resolve)
        },
        {
          path: '/student/record/create',
          meta: {auth: true, title: '发布履历'},
          component: resolve => require(['views/student/resume/record/create'], resolve)
        },
        {
          path: '/student/resume/quality',
          meta: {auth: true, title: '素质维护'},
          component: resolve => require(['views/student/resume/quality/'], resolve)
        },
        {
          path: '/student/resume/quality/:id',
          meta: { auth: true, title: '素质详情' },
          component: resolve => require(['views/student/resume/quality/detail'], resolve)
        },
        {
          path: '/student/resume/create',
          meta: {auth: true, title: '发布素质'},
          component: resolve => require(['views/student/resume/quality/create'], resolve)
        },
        {
          path: '/student/train',
          meta: {auth: true, title: '加强班'},
          component: resolve => require(['views/student/train/'], resolve)
        },
        {
          path: '/student/career',
          meta: {auth: true, title: '职业生涯'},
          component: resolve => require(['views/student/career/'], resolve)
        },
        // 企业入驻缴费
        {
          path: '/company/pay',
          meta: {auth: true, title: '入驻缴费'},
          component: resolve => require(['views/company/company-pay'], resolve)
        },
        // 企业入驻缴费成功
        {
          path: '/company/success',
          meta: {auth: true, title: '缴费成功'},
          component: resolve => require(['views/company/pay-success'], resolve)
        },
        // region 企业
        {
          path: '/company/home',
          meta: {auth: true, title: '企业面板'},
          component: resolve => require(['views/company/home'], resolve)
        },
        {
          path: '/company/list',
          meta: {auth: true, title: '企业列表'},
          component: resolve => require(['views/company/list'], resolve)
        },
        {
          path: '/company/info/:id',
          meta: {auth: true, title: '企业主页'},
          component: resolve => require(['views/company/info'], resolve)
        },
        {
          path: '/company/settings',
          meta: {auth: true, title: '企业设置'},
          component: resolve => require(['views/company/settings'], resolve)
        },
        {
          path: '/company/guide',
          meta: {auth: true, title: '企业引导'},
          component: resolve => require(['views/company/guide'], resolve)
        },
        {
          path: '/company/approve',
          meta: {auth: true, title: '企业认证'},
          component: resolve => require(['views/company/approve'], resolve)
        },
        {
          path: '/company/students',
          meta: {auth: true, title: '岗位候选人'},
          component: resolve => require(['views/company/students'], resolve)
        },
        {
          path: '/company/practice',
          meta: {auth: true, title: '企业实习'},
          component: resolve => require(['views/company/practice'], resolve)
        },
        {
          path: '/company/agreement',
          meta: {auth: true, title: '岗位协议'},
          component: resolve => require(['views/company/agreement'], resolve)
        },
        {
          path: '/company/course',
          meta: {auth: true, title: '课程资料'},
          component: resolve => require(['views/company/'], resolve),
          redirect: '/company/course',
          children: [
            { path: '/company/course',
              meta: {auth: true, title: '课程资料'},
              component: resolve => require(['views/company/course'], resolve)},
            {
              path: '/company/course/create',
              meta: {auth: true, title: '课程资料发布'},
              component: resolve => require(['views/company/course-create'], resolve)
            }
          ]
        },
        {
          path: '/company/course/update/:id',
          meta: {auth: true, title: '企业课程资料'},
          component: resolve => require(['views/company/course-update'], resolve)
        },
        {
          path: '/company/invite',
          meta: {auth: true, title: '人才邀请', keepAlive: true},
          component: resolve => require(['views/company/'], resolve),
          redirect: '/company/invite',
          children: [
            {
              path: '/student/resume/my',
              meta: {auth: true, title: '数据简历'},
              component: resolve => require(['views/student/resume/my'], resolve)
            },
            {
              path: '/company/invite',
              meta: {auth: true, title: '人才邀请', keepAlive: true},
              component: resolve => require(['views/company/invite'], resolve)
            }
          ]
        },
        {
          path: '/company/resume/:id',
          meta: { auth: true, title: '人才数据简历' },
          component: resolve => require(['views/company/resume'], resolve)
        },
        {
          path: '/company/novice',
          meta: {auth: true, title: '企业新手引导'},
          component: resolve => require(['views/company/company-guide'], resolve)
        },
        {
          path: '/company/user',
          meta: {auth: true, title: '企业用户'},
          component: resolve => require(['views/company/user'], resolve)
        },
        {
          path: '/company/interview',
          meta: {auth: true, title: '面试管理'},
          component: resolve => require(['views/company/interview'], resolve)
        },
        {
          path: '/test/detail/:examId',
          meta: {auth: true, title: '答题详情'},
          component: resolve => require(['views/company/answerdetail'], resolve)
        },
        {
          path: '/company/statistical',
          meta: {auth: true, title: '答题统计'},
          component: resolve => require(['views/company/statistical'], resolve)
        },
        // endregion

        // region 辅导老师
        {
          path: '/teacher/class',
          meta: {auth: true, title: '我的'},
          component: resolve => require(['views/teacher/class'], resolve)
        },
        {
          path: '/teacher/students',
          meta: {auth: true, title: '我的学生'},
          component: resolve => require(['views/teacher/students'], resolve)
        },
        {
          path: '/teacher/offline',
          meta: {auth: true, title: '我的强化班'},
          component: resolve => require(['views/teacher/offline'], resolve)
        },
        {
          path: '/teacher/log-review',
          meta: {auth: true, title: '日志评审'},
          component: resolve => require(['views/teacher/log-review'], resolve)
        },
        {
          path: '/teacher/log-review/detail/:id',
          meta: {auth: true, title: '日志评审详情'},
          component: resolve => require(['views/teacher/log-review-deatil'], resolve)
        },
        // endregion

        // region 主播
        {
          path: '/anchor/info/:id',
          meta: {auth: true, title: '主播主页'},
          component: resolve => require(['views/anchor/info'], resolve)
        },
        {
          path: '/anchor/wait',
          meta: {auth: true, title: '审核中'},
          component: resolve => require(['views/anchor/wait'], resolve)
        },
        {
          path: '/anchor/home',
          meta: {auth: true, title: '主播面板'},
          component: resolve => require(['views/anchor/home'], resolve)
        },
        {
          path: '/anchor/settings',
          meta: {auth: true, title: '主播设置'},
          component: resolve => require(['views/anchor/settings'], resolve)
        },
        {
          path: '/anchor/register',
          meta: {auth: true, title: '主播引导'},
          component: resolve => require(['views/anchor/register'], resolve)
        },
        {
          path: '/anchor/approve',
          meta: {auth: true, title: '主播认证'},
          component: resolve => require(['views/anchor/approve'], resolve)
        },
        {
          path: '/anchor/courses/list',
          meta: {auth: true, title: '我的课程'},
          component: resolve => require(['views/anchor/course-list'], resolve)
        },
        {
          path: '/anchor/evaluate',
          meta: {auth: true, title: '评价信用'},
          component: resolve => require(['views/anchor/evaluate'], resolve)
        },
        {
          path: '/anchor/live/list',
          meta: {auth: true, title: '我的直播'},
          component: resolve => require(['views/anchor/live-list'], resolve)
        },
        {
          path: '/anchor/guide',
          meta: {auth: true, title: '升级主播'},
          component: resolve => require(['views/anchor/guide'], resolve)
        },

        // endregion

        // region 学校
        {
          path: '/school/home',
          meta: {auth: true, title: '学校面板'},
          component: resolve => require(['views/school/home'], resolve)
        },
        {
          path: '/school/main',
          meta: {auth: true, title: '学校主页'},
          component: resolve => require(['views/school/main'], resolve)
        },
        {
          path: '/school/students',
          meta: {auth: true, title: '学生'},
          component: resolve => require(['views/school/students'], resolve)
        },
        {
          path: '/school/employment',
          meta: {auth: true, title: '就业'},
          component: resolve => require(['views/school/employment'], resolve)
        },
        {
          path: '/school/practice',
          meta: {auth: true, title: '实习'},
          component: resolve => require(['views/school/practice'], resolve)
        },
        {
          path: '/school/agreement',
          meta: {auth: true, title: '协议'},
          component: resolve => require(['views/school/agreement'], resolve)
        },
        {
          path: '/school/report',
          meta: {auth: true, title: '统计报表'},
          component: resolve => require(['views/school/report'], resolve)
        },
        {
          path: '/school/user',
          meta: {auth: true, title: '学校用户'},
          component: resolve => require(['views/school/user'], resolve)
        },
        {
          path: '/school/settings',
          meta: {auth: true, title: '学校设置'},
          component: resolve => require(['views/school/settings'], resolve)
        },
        // endregion

        // region 日志
        {
          path: '/blog',
          meta: {auth: true, title: '日志列表'},
          component: resolve => require(['views/blog'], resolve)
        },
        {
          path: '/blog/my',
          meta: {auth: true, title: '我的日志'},
          component: resolve => require(['views/blog/my'], resolve)
        },
        {
          path: '/blog/create/:id',
          meta: {auth: true, title: '创建日志'},
          component: resolve => require(['views/blog/create'], resolve)
        },
        {
          path: '/blog/detail/:id',
          meta: {auth: true, title: '日志详情'},
          component: resolve => require(['views/blog/detail'], resolve)
        },
        {
          path: '/blog/audit',
          meta: {auth: true, title: '日志评审'},
          component: resolve => require(['views/blog/audit'], resolve)
        },
        // endregion

        // region 考试
        {
          path: '/exam/list',
          meta: {auth: true, title: '考试大厅'},
          component: resolve => require(['views/exam/list'], resolve)
        },
        {
          path: '/exam/test',
          meta: {auth: true, title: '提交申请'},
          component: resolve => require(['views/exam/submit'], resolve)
        },
        {
          path: '/exam/success',
          meta: {auth: true, title: '考试申请'},
          component: resolve => require(['views/exam/success'], resolve)
        },
        {
          path: '/exam/detail/:id',
          meta: {auth: true, title: '考试详情'},
          component: resolve => require(['views/exam/detail'], resolve)
        },
        {
          path: '/exam/teacher',
          meta: {auth: true, title: '我的监考'},
          component: resolve => require(['views/exam/teacher'], resolve)
        },
        {
          path: '/exam/my',
          meta: {auth: true, title: '我的考试'},
          component: resolve => require(['views/exam/my'], resolve)
        },
        {
          path: '/exam/result/:id',
          meta: {auth: true, title: '考试结果'},
          component: resolve => require(['views/exam/result'], resolve)
        },
        {
          path: '/exam/exam/:id',
          meta: {auth: true, title: '考试'},
          component: resolve => require(['views/exam/exam'], resolve)
        },
        {
          path: '/exam/codewars/:id',
          meta: {auth: true, title: '考试'},
          component: resolve => require(['views/exam/codewars'], resolve)
        },
        // endregion

        // region 职业
        {
          path: '/profession',
          meta: {auth: true, title: '职业'},
          component: resolve => require(['views/profession/'], resolve)
        },
        {
          path: '/profession/detail/:id',
          meta: {auth: true, title: '职业详情'},
          component: resolve => require(['views/profession/detail'], resolve)
        },

        // 知识点
        {
          path: '/skill/detail/:id',
          meta: {auth: true, title: '技能点详情'},
          component: resolve => require(['views/skill/detail'], resolve)
        },
        // endregion

        // region 岗位
        {
          path: '/position',
          meta: {auth: true, title: '岗位'},
          component: resolve => require(['views/position/'], resolve)
        },
        {
          path: '/position/detail/:id',
          meta: {auth: true, title: '岗位详情'},
          component: resolve => require(['views/position/detail'], resolve)
        },
        {
          path: '/position/student/my',
          meta: {auth: true, title: '我的岗位'},
          component: resolve => require(['views/position/student/my'], resolve)
        },
        {
          path: '/position/company/my',
          meta: {auth: true, title: '定制岗位'},
          component: resolve => require(['views/position/company/'], resolve),
          redirect: '/position/company/my',
          children: [
            {
              path: '/position/company/my',
              meta: {auth: true, title: '定制岗位'},
              component: resolve => require(['views/position/company/my'], resolve)
            },
            {
              path: '/position/create',
              meta: {auth: true, title: '发布岗位'},
              component: resolve => require(['views/position/create'], resolve)
            }
          ]
        },
        {
          path: '/position/company/test',
          meta: {auth: true, title: '岗位测试'},
          component: resolve => require(['views/position/company/test'], resolve)
        },
        {
          path: '/company/test/detail/:id/:companyId',
          meta: {auth: true, title: '岗位详情'},
          component: resolve => require(['views/company/companydetail'], resolve)
        },
        {
          path: '/position/company/test/creat',
          meta: {auth: true, title: '新增考题'},
          component: resolve => require(['views/company/creat-topic'], resolve)
        },

        {
          path: '/position/modification/:id',
          meta: {auth: true, title: '修改岗位'},
          component: resolve => require(['views/position/modification'], resolve)
        },
        // endregion

        // region 课程
        {
          path: '/course',
          meta: {auth: true, title: '课程'},
          component: resolve => require(['views/course/'], resolve)
        },
        {
          path: '/course/create',
          meta: {auth: true, title: '发布新课程'},
          component: resolve => require(['views/course/create'], resolve)
        },
        {
          path: '/course/update/:id',
          meta: {auth: true, title: '修改课程'},
          component: resolve => require(['views/course/update'], resolve)
        },
        {
          path: '/course/buy',
          meta: {auth: true, title: '我的课程'},
          component: resolve => require(['views/course/buy'], resolve)
        },
        {
          path: '/course/:id/detail',
          meta: {auth: true, title: '课程详情'},
          component: resolve => require(['views/course/detail'], resolve)
        },
        {
          path: '/course/release',
          meta: {auth: true, title: '发布的课程'},
          component: resolve => require(['views/course/release'], resolve)
        },
        {
          path: '/course/:id/rate',
          meta: {auth: true, title: '课程评价'},
          component: resolve => require(['views/course/rate'], resolve)
        },
        {
          path: '/course/:id/study',
          meta: {auth: true, title: '听课'},
          component: resolve => require(['views/course/study'], resolve)
        },
        // endregion

        // region 直播
        {
          path: '/live',
          meta: {auth: true, title: '直播'},
          component: resolve => require(['views/live/'], resolve)
        },
        {
          path: '/live/release',
          meta: {auth: true, title: '发布的直播'},
          component: resolve => require(['views/live/release'], resolve)
        },
        // endregion

        // region 知识库
        {
          path: '/knowledge/my',
          meta: {auth: true, title: '我的知识库'},
          component: resolve => require(['views/knowledge/my'], resolve)
        },
        {
          path: '/knowledge/detail/:id',
          meta: {auth: true, title: '知识库详情'},
          component: resolve => require(['views/knowledge/detail'], resolve)
        },
        {
          path: '/knowledge/create/:id',
          meta: {auth: true, title: '知识库创建'},
          component: resolve => require(['views/knowledge/create'], resolve)
        },
        {
          path: '/knowledge/update/:id',
          meta: {auth: true, title: '知识库修改'},
          component: resolve => require(['views/knowledge/update'], resolve)
        },
        // endregion
        // region  专业课程
        {
          path: '/majorcourses',
          meta: {auth: true, title: '专业课'},
          component: resolve => require(['views/majorcourses/'], resolve)
        },
        {
          path: '/major/guide',
          meta: {auth: true, title: '我的专业'},
          component: resolve => require(['views/majorcourses/guide'], resolve)
        },
        {
          path: '/majorcourses/my/:id',
          meta: {auth: false, title: '我的专业'},
          component: resolve => require(['views/majorcourses/my'], resolve)
        },
        {
          path: '/majorcourses/detail/:id',
          meta: {auth: true, title: '专业课详情'},
          component: resolve => require(['views/majorcourses/detail'], resolve)
        },
        // endregion
        // region 排行
        {
          path: '/rank',
          meta: {auth: true, title: '排行'},
          component: resolve => require(['views/rank/'], resolve)
        },
        // news 资讯
        {
          path: '/news',
          meta: {auth: true, title: '资讯'},
          component: resolve => require(['views/news/'], resolve)
        },
        {
          path: '/news/:id',
          meta: {auth: true, title: '资讯详情'},
          component: resolve => require(['views/news/detail'], resolve)
        },
        {
          path: '/about/intro',
          meta: {auth: true, title: '平台介绍'},
          component: resolve => require(['views/about/intro'], resolve)
        },
        {
          path: '/about/guide',
          meta: {auth: true, title: '新手指南'},
          component: resolve => require(['views/about/guide'], resolve)
        },
        {
          path: '/about/anchor',
          meta: {auth: true, title: '主播介绍'},
          component: resolve => require(['views/about/anchor'], resolve)
        },
        {
          path: '/about/declaration',
          meta: {auth: true, title: '法律声明'},
          component: resolve => require(['views/about/declaration'], resolve)
        },
        {
          path: '/about/privacy',
          meta: {auth: true, title: '隐私政策'},
          component: resolve => require(['views/about/privacy'], resolve)
        },
        {
          path: '/about/faq',
          meta: {auth: true, title: '常见问题'},
          component: resolve => require(['views/about/faq'], resolve)
        },
        {
          path: '/about/feedback',
          meta: {auth: true, title: '意见反馈'},
          component: resolve => require(['views/about/feedback'], resolve)
        },
        // endregion

        // region 用户
        {
          path: '/user/settings',
          meta: { auth: true, title: '系统设置' },
          component: resolve => require(['views/user/settings'], resolve)
        },
        {
          path: '/user/notice',
          meta: {auth: true, title: '我的通知'},
          component: resolve => require(['views/user/notice/'], resolve)
        },
        {
          path: '/user/message',
          meta: {auth: true, title: '我的消息'},
          component: resolve => require(['views/user/message/'], resolve)
        },
        {
          path: '/user/message/detail/:id',
          meta: {auth: true, title: '消息详情'},
          component: resolve => require(['views/user/message/detail'], resolve)
        },
        {
          path: '/user/comment',
          meta: {auth: true, title: '我的评论'},
          component: resolve => require(['views/user/comment/'], resolve)
        },
        {
          path: '/user/order',
          meta: {auth: true, title: '我的订单'},
          component: resolve => require(['views/user/order/'], resolve)
        },
        {
          path: '/pay/weixin/:id',
          meta: { auth: true, title: '微信支付' },
          component: resolve => require(['views/user/pay/weixin'], resolve)
        },
        {
          path: '/user/coupon',
          meta: {auth: true, title: '我的卡券'},
          component: resolve => require(['views/user/coupon/'], resolve)
        },
        {
          path: '/user/balance',
          meta: {auth: true, title: '我的职豆'},
          component: resolve => require(['views/user/balance/'], resolve)
        },
        {
          path: '/user/charge',
          meta: {auth: true, title: '充值中心'},
          component: resolve => require(['views/user/balance/charge'], resolve)
        },
        {
          path: '/user/earning',
          meta: {auth: true, title: '我的收益'},
          component: resolve => require(['views/user/earning/'], resolve)
        },
        {
          path: '/user/profile',
          meta: {auth: true, title: '个人资料'},
          component: resolve => require(['views/user/profile'], resolve)
        },
        {
          path: '/user/password',
          meta: {auth: true, title: '修改密码'},
          component: resolve => require(['views/user/password'], resolve)
        },
        {
          path: '/user/bindphone',
          meta: {auth: true, title: '修改绑定手机号'},
          component: resolve => require(['views/user/bindphone'], resolve)
        },
        {
          path: '/user/cashaccount',
          meta: {auth: true, title: '修改提现账户'},
          component: resolve => require(['views/user/cashaccount'], resolve)
        },
        {
          path: '/user/withdrawal',
          meta: {auth: true, title: '提现'},
          component: resolve => require(['views/user/withdrawal1'], resolve)
        },
        {
          path: '/user/authenticate',
          meta: {auth: true, title: '安全认证'},
          component: resolve => require(['views/user/authenticate/'], resolve)
        },
        // endregion

        // region 开发示例
        ...(process.env.NODE_ENV === 'production' ? [] : [
          {
            path: '/dev/blank',
            meta: {auth: true, title: '空白页'},
            component: resolve => require(['views/dev/blank'], resolve)
          },
          {
            path: '/dev/rule',
            meta: {auth: true, title: '规范文档'},
            component: resolve => require(['views/dev/rule'], resolve)
          },
          {
            path: '/dev/permission',
            meta: {auth: true, title: '权限文档'},
            component: resolve => require(['views/dev/permission'], resolve)
          },
          {
            path: '/dev/colors',
            meta: {auth: true, title: '颜色'},
            component: resolve => require(['views/dev/theme/colors'], resolve)
          },
          {
            path: '/dev/typography',
            meta: {auth: true, title: '排版'},
            component: resolve => require(['views/dev/theme/typography'], resolve)
          },
          // UI-Elements base/buttons
          {
            path: '/dev/cards',
            meta: {auth: true, title: '卡片'},
            component: resolve => require(['views/dev/base/cards'], resolve)
          },
          {
            path: '/dev/drag',
            meta: {auth: true, title: '拖拽'},
            component: resolve => require(['views/dev/base/drag'], resolve)
          },
          {
            path: '/dev/collapses',
            meta: {auth: true, title: '折叠内容'},
            component: resolve => require(['views/dev/base/collapses'], resolve)
          },
          {
            path: '/dev/jumbotrons',
            meta: {auth: true, title: '大标牌'},
            component: resolve => require(['views/dev/base/jumbotrons'], resolve)
          },
          {
            path: '/dev/list-groups',
            meta: {auth: true, title: '列表'},
            component: resolve => require(['views/dev/base/list-groups'], resolve)
          },
          {
            path: '/dev/tabs',
            meta: {auth: true, title: '标签切换'},
            component: resolve => require(['views/dev/base/tabs'], resolve)
          },
          {
            path: '/dev/navs',
            meta: {auth: true, title: '标签页'},
            component: resolve => require(['views/dev/base/navs'], resolve)
          },
          {
            path: '/dev/navbars',
            meta: {auth: true, title: '导航条'},
            component: resolve => require(['views/dev/base/navbars'], resolve)
          },
          {
            path: '/dev/paginations',
            meta: {auth: true, title: '分页条'},
            component: resolve => require(['views/dev/base/paginations'], resolve)
          },
          {
            path: '/dev/progress-bars',
            meta: {auth: true, title: '进度条'},
            component: resolve => require(['views/dev/base/progress-bars'], resolve)
          },
          {
            path: '/dev/badges',
            meta: {auth: true, title: '徽章'},
            component: resolve => require(['views/dev/base/badges'], resolve)
          },
          {
            path: '/dev/fullcalendar',
            meta: {auth: true, title: '日历'},
            component: resolve => require(['views/dev/base/full-calendar'], resolve)
          },
          {
            path: '/dev/vue-tree',
            meta: {auth: true, title: 'VueTree-树组件'},
            component: resolve => require(['views/dev/base/vue-tree'], resolve)
          },
          {
            path: '/dev/liquor-tree',
            meta: {auth: true, title: 'LiquorTree-树组件'},
            component: resolve => require(['views/dev/base/liquor-tree'], resolve)
          },
          {
            path: '/dev/standard-buttons',
            meta: {auth: true, title: '按钮'},
            component: resolve => require(['views/dev/buttons/standard-buttons'], resolve)
          },
          {
            path: '/dev/button-groups',
            meta: {auth: true, title: '按钮组'},
            component: resolve => require(['views/dev/buttons/button-groups'], resolve)
          },
          {
            path: '/dev/dropdowns',
            meta: {auth: true, title: '下拉菜单'},
            component: resolve => require(['views/dev/buttons/dropdowns'], resolve)
          },
          // Forms form
          {
            path: '/dev/forms',
            meta: {auth: true, title: '表单'},
            component: resolve => require(['views/dev/form/forms'], resolve)
          },
          {
            path: '/dev/form-sample',
            meta: {auth: true, title: '表单示例'},
            component: resolve => require(['views/dev/form/form-sample'], resolve)
          },
          {
            path: '/dev/switches',
            meta: {auth: true, title: '开关'},
            component: resolve => require(['views/dev/form/switches'], resolve)
          },
          {
            path: '/dev/cascader',
            meta: {auth: true, title: '级联选择'},
            component: resolve => require(['views/dev/form/cascader/link-area'], resolve)
          },
          {
            path: '/dev/date-picker',
            meta: {auth: true, title: '时间选择器'},
            component: resolve => require(['views/dev/form/date-picker'], resolve)
          },
          {
            path: '/dev/score',
            meta: {auth: true, title: '评分'},
            component: resolve => require(['views/dev/form/score'], resolve)
          },
          {
            path: '/dev/screen',
            meta: {auth: true, title: '筛选框'},
            component: resolve => require(['views/dev/form/screen'], resolve)
          },
          {
            path: '/dev/select',
            meta: {auth: true, title: '特殊选择框'},
            component: resolve => require(['views/dev/form/select'], resolve)
          },
          {
            path: '/dev/cut',
            meta: {auth: true, title: '传图裁剪'},
            component: resolve => require(['views/dev/form/cut'], resolve)
          },
          {
            path: '/dev/more-upload',
            meta: {auth: true, title: '多图上传'},
            component: resolve => require(['views/dev/form/more-upload'], resolve)
          },
          // Notice notice
          {
            path: '/dev/popovers',
            meta: {auth: true, title: '浮动窗口'},
            component: resolve => require(['views/dev/notice/popovers'], resolve)
          },
          {
            path: '/dev/tooltips',
            meta: {auth: true, title: '浮动提示'},
            component: resolve => require(['views/dev/notice/tooltips'], resolve)
          },
          {
            path: '/dev/toast',
            meta: {auth: true, title: '提示'},
            component: resolve => require(['views/dev/notice/toast'], resolve)
          },
          {
            path: '/dev/notifications',
            meta: {auth: true, title: 'Notifications提示'},
            component: resolve => require(['views/dev/notice/notifications'], resolve)
          },
          {
            path: '/dev/alerts',
            meta: {auth: true, title: '静态提醒'},
            component: resolve => require(['views/dev/notice/alerts'], resolve)
          },
          {
            path: '/dev/modals',
            meta: {auth: true, title: '模态窗口'},
            component: resolve => require(['views/dev/notice/modals'], resolve)
          },
          // Editor editor
          {
            path: '/dev/mavon-editor',
            meta: {auth: true, title: 'MavonEditor-markdown编辑器'},
            component: resolve => require(['views/dev/editor/mavon-editor'], resolve)
          },
          {
            path: '/dev/vue2-editor',
            meta: {auth: true, title: 'Vue2Editor'},
            component: resolve => require(['views/dev/editor/vue2-editor'], resolve)
          },
          {
            path: '/dev/vue-quill-editor',
            meta: {auth: true, title: 'VueQuillEditor'},
            component: resolve => require(['views/dev/editor/vue-quill-editor'], resolve)
          },
          {
            path: '/dev/vue-codemirror',
            meta: {auth: true, title: 'VueCodeMirror'},
            component: resolve => require(['views/dev/editor/vue-code-mirror'], resolve)
          },
          // Tables tables
          {
            path: '/dev/tables',
            meta: {auth: true, title: '表格样式'},
            component: resolve => require(['views/dev/tables/tables'], resolve)
          },
          {
            path: '/dev/v2table',
            meta: {auth: true, title: 'V2-table'},
            component: resolve => require(['views/dev/tables/v2-table'], resolve)
          },
          {
            path: '/dev/vue-datatable',
            meta: {auth: true, title: 'Vue2DataTable'},
            component: resolve => require(['views/dev/tables/vue-datatable'], resolve)
          },
          {
            path: '/dev/table-sample',
            meta: {auth: true, title: '表格示例'},
            component: resolve => require(['views/dev/tables/table-sample'], resolve)
          },
          // Icons icons
          {
            path: '/dev/font-awesome',
            meta: {auth: true, title: 'Icon-FontAwesome'},
            component: resolve => require(['views/dev/icons/font-awesome'], resolve)
          },
          {
            path: '/dev/simple-line-icons',
            meta: {auth: true, title: 'Icon-SimpleLineIcons'},
            component: resolve => require(['views/dev/icons/simple-line-icons'], resolve)
          },
          {
            path: '/dev/material-design-iconic',
            meta: {auth: true, title: 'Icon-MaterialDesignIconic'},
            component: resolve => require(['views/dev/icons/material-design-iconic'], resolve)
          },
          // Widgets widgets
          {
            path: '/dev/widgets',
            meta: {auth: true, title: '小部件'},
            component: resolve => require(['views/dev/widgets/widgets'], resolve)
          },
          {
            path: '/dev/pdf',
            meta: {auth: true, title: 'PDF插件'},
            component: resolve => require(['views/dev/widgets/pdf'], resolve)
          },
          {
            path: '/dev/simple-page',
            meta: {auth: true, title: '常用页面'},
            component: resolve => require(['views/dev/widgets/simple-page'], resolve)
          },
          // Effect effect
          {
            path: '/dev/animate',
            meta: {auth: true, title: '动画效果'},
            component: resolve => require(['views/dev/effect/vue2-animate'], resolve)
          },
          {
            path: '/dev/carousels',
            meta: {auth: true, title: 'Bootstrap滑动图片'},
            component: resolve => require(['views/dev/effect/carousels'], resolve)
          },
          {
            path: '/dev/swiper',
            meta: {auth: true, title: 'Swiper滑动图片'},
            component: resolve => require(['views/dev/effect/awesome-swiper'], resolve)
          },
          {
            path: '/dev/draggable',
            meta: {auth: true, title: 'Draggable拖动'},
            component: resolve => require(['views/dev/effect/draggable'], resolve)
          },
          {
            path: '/dev/affix',
            meta: {auth: true, title: 'Affix锚点'},
            component: resolve => require(['views/dev/effect/vue-affix'], resolve)
          },
          {
            path: '/dev/waterfall',
            meta: {auth: true, title: 'Waterfall瀑布流'},
            component: resolve => require(['views/dev/effect/vue-waterfall'], resolve)
          },
          // Charts charts
          {
            path: '/dev/charts',
            meta: {auth: true, title: 'charts.js图表'},
            component: resolve => require(['views/dev/charts/charts'], resolve)
          },
          {
            path: '/dev/echarts',
            meta: {auth: true, title: 'echarts图表'},
            component: resolve => require(['views/dev/charts/echats'], resolve)
          },
          {
            path: '/dev/qr-code',
            meta: {auth: true, title: '二维码'},
            component: resolve => require(['views/dev/charts/qr-code'], resolve)
          },
          {
            path: '/dev/map-baidu',
            meta: {auth: true, title: '百度地图'},
            component: resolve => require(['views/dev/charts/baidu-map'], resolve)
          },
          // Video video
          // {
          //   path: '/dev/vue-video',
          //   meta: {auth: true, title: 'VueVideo'},
          //   component: resolve => require(['views/dev/video/vue-video'], resolve)
          // },
          {
            path: '/dev/vue-dplayer',
            meta: {auth: true, title: 'VueDPlayer'},
            component: resolve => require(['views/dev/video/vue-dplayer'], resolve)
          },
          {
            path: '/dev/ugc-upvideo',
            meta: {auth: true, title: '上传视频'},
            component: resolve => require(['views/dev/video/ugc-upvideo'], resolve)
          },
          {
            path: '/dev/video-play',
            meta: {auth: true, title: '视频播放'},
            component: resolve => require(['views/dev/video/video-play'], resolve)
          }
        ])
      // endregion
      ]
    },
    {
      path: '/index',
      meta: {auth: true, title: '首页', name: 'index'},
      component: resolve => require(['views/index/index'], resolve)
    },
    // region 登录注册
    // 身份验证
    {
      path: '/login',
      meta: {auth: false, title: '登录'},
      component: resolve => require(['views/auth/login'], resolve)
    },
    {
      path: '/register',
      meta: {auth: false, title: '注册'},
      component: resolve => require(['views/auth/register'], resolve)
    },
    {
      path: '/register/activate/:token',
      meta: { auth: false, title: '激活' },
      component: resolve => require(['views/auth/register-activate'], resolve)
    },
    {
      path: '/forgot-password',
      meta: {auth: false, title: '忘记密码'},
      component: resolve => require(['views/auth/forgot-password'], resolve)
    },
    {
      path: '/company/positiontest/:id',
      meta: {auth: false, title: '考生信息登记'},
      component: resolve => require(['views/positiontest/infocollect'], resolve)
    },
    {
      path: '/company/positiontest/knowledge/:id',
      meta: {auth: false, title: '勾选知识点'},
      component: resolve => require(['views/positiontest/knowledgePoint'], resolve)
    },
    {
      path: '/company/position/test/answer',
      meta: {auth: false, title: '考题'},
      component: resolve => require(['views/positiontest/answer'], resolve)
    },
    {
      path: '/company/position/test/score',
      meta: {auth: false, title: '得分'},
      component: resolve => require(['views/positiontest/score'], resolve)
    },
    // 员工测评
    {
      path: '/company/employeestest/index',
      meta: {auth: false, title: '员工测评'},
      component: resolve => require(['views/employeestest/index'], resolve)
    },
    {
      path: '/company/employeestest/position/:id',
      meta: {auth: false, title: '员工测评'},
      component: resolve => require(['views/employeestest/position'], resolve)
    },
    {
      path: '/company/employeestest/skill/:id',
      meta: {auth: false, title: '员工测评'},
      component: resolve => require(['views/employeestest/skill'], resolve)
    },
    {
      path: '/company/employeestest/test',
      meta: {auth: false, title: '员工测评'},
      component: resolve => require(['views/employeestest/test'], resolve)
    },
    {
      path: '/company/employeestest/result',
      meta: {auth: false, title: '员工测评'},
      component: resolve => require(['views/employeestest/result'], resolve)
    },
    // endregion

    // region Default
    {
      path: '/500', // 404
      meta: {auth: false, title: '项目尚未开始'},
      component: resolve => require(['views/pages/page-500'], resolve)
    },
    {
      path: '/auth', // auth认证
      meta: {auth: false, title: '实名认证结果'},
      component: resolve => require(['views/user/auth/auth'], resolve)
    },
    {
      path: '/404', // 404
      meta: {auth: false, title: '页面未找到'},
      component: resolve => require(['views/pages/page-404'], resolve)
    },
    {
      path: '*', // 其他页面
      redirect: '/404'
    }
  // endregion
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js